<template>
  <div>
    <el-upload
      class="avatar-uploader"
      action=""
      :http-request="uploadCover"
      :show-file-list="false"
      style="display: none"
      ref="coverUpload"
    >
      <i class="el-icon-plus avatar-uploader-icon" id="imgInput"></i>
    </el-upload>
    <quill-editor
      v-model="content"
      ref="myQuillEditor"
      :options="editorOption"
      class="ql-editor"
    ></quill-editor>
    <div style="display:none">
      <el-upload
        v-loading.fullscreen.lock="fullscreenLoading"
        action="#"
        :http-request="uploadImg"
        :before-upload="beforeUpload"
        :on-success="handleSuccess"
        :on-progress="uploadIng"
      >
        <el-button size="small" class="uploadVoiceBtn" type="primary"
          >upload</el-button
        >
      </el-upload>
    </div>
    <div style="display:none">
      <el-upload
        v-loading.fullscreen.lock="fullscreenLoading"
        action="#"
        :http-request="uploadVideo"
        :on-progress="uploadIng"
      >
        <el-button size="small" class="uploadVideoBtn" type="primary"
          >upload</el-button
        >
      </el-upload>
    </div>
  </div>
</template>

<script>
import { quillEditor, Quill } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import FileHandler from "@/utils/file";
export default {
  data() {
    return {
      fullscreenLoading: false,
      content: "",
      editorOption: {
        placeholder: "请在这里输入",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              [{ size: ["small", false, "large", "huge"] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              ["blockquote", "code-block"],
              ["link", "image", "video"],
              ["voice"] //新新增的工具
            ],
            handlers: {
              image: function(value) {
                if (value) {
                  document.getElementById("imgInput").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              voice: function() {
                //新增工具方法，即点击时模仿点击上传组件的按钮
                document.querySelector(".uploadVoiceBtn").click();
              },
              video: function() {
                document.querySelector(".uploadVideoBtn").click();
              }
            }
          }
        },
        initVoiceButton: function() {
          //初始化"voice"按钮样式
          const voiceButton = document.querySelector(".ql-voice"); //"ql-" 是插件自动加的前缀

          // 新增样式，使用fontawesome初始化图标的样式
          // voiceButton.classList.add("el-icon-microphone");
          // voiceButton.classList.add("fa-volume-up");
          voiceButton.classList.add("fa-lg");

          // 当然，可以直接手写样式，如：
          // voiceButton.style.cssText = "width:80px; border:1px solid #ccc; border-radius:5px;";
          // voiceButton.innerText = "上传音频";
        }
      }
    };
  },
  props: ["detail", "uploadUrl"],
  components: {
    quillEditor
  },
  watch: {
    content(val) {
      this.$emit("change-con", val);
    },
    detail(val) {
      this.content = val;
    }
  },
  mounted() {
    this.content = this.detail;
    this.editorOption.initVoiceButton(); //初始化音频图标，这样才能显示
  },
  methods: {
    beforeUpload(file) {
      // file.type好像只能返回图片的格式，其他的将会是 ""， 所以需要自己获取后缀名判断文件格式
      let pointIndex = file.name.lastIndexOf(".");
      let fileType = file.name.substring(pointIndex + 1); //获取到文件后缀名
      // if (fileType !== 'mp3' && fileType !== 'ogg' && fileType !== 'wav') {
      if (
        fileType !== "mp3" &&
        fileType !== "ogg" &&
        fileType !== "wav" &&
        fileType !== "mp4"
      ) {
        this.$message.error(
          "你选择的文件不是音频哦，仅支持wav,mp4,mp3和ogg格式"
        );
        return false;
      }
    },
    handleSuccess(res) {
      this.fullscreenLoading = false;
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill;
      if (res.code === 0) {
        // 如果上传成功
        let length = quill.getSelection().index; // 获取光标所在位置

        let BlockEmbed = Quill.import("blots/block/embed");
        class AudioBlot extends BlockEmbed {
          static create(value) {
            let node = super.create();
            node.setAttribute("src", value.url); //设置audio的src属性
            node.setAttribute("controls", true); //设置audio的controls，否则他将不会显示
            node.setAttribute("controlsList", "nodownload"); //设置audio的下载功能为不能下载
            node.setAttribute("id", "voice"); //设置一个id
            return node;
          }

          // static value(node) {
          //  return {
          //   url: node.getAttribute('src')
          //  };
          // }
        }
        AudioBlot.blotName = "audio";
        AudioBlot.tagName = "audio"; //自定义的标签为audio
        Quill.register(AudioBlot);

        // insertEmbed(index: Number(插入的位置), type: String(标签类型), value: any(参数，将传入到create的方法中去), source: String = 'api')
        quill.insertEmbed(length, "audio", { url: res.data.url }, "api");
        quill.setSelection(length + 1); //光标位置向后移动一位
      } else {
        this.$message.error(res.msg); // 上传失败，提示错误信息
      }
    },
    uploadIng() {
      this.fullscreenLoading = true;
    },
    uploadImg(data) {
      let file = data.file;
      let uploadUrl = this.uploadUrl;
      FileHandler.uploadFile(uploadUrl, file).then(res => {
        // this.fullscreenLoading = false;
        this.fullscreenLoading = false;
        // 获取富文本组件实例
        let quill = this.$refs.myQuillEditor.quill;
        let length = quill.getSelection().index; // 获取光标所在位置

        let BlockEmbed = Quill.import("blots/block/embed");
        class AudioBlot extends BlockEmbed {
          static create() {
            let node = super.create();
            node.setAttribute("src", res.url); //设置audio的src属性
            node.setAttribute("controls", true); //设置audio的controls，否则他将不会显示
            node.setAttribute("controlsList", "nodownload"); //设置audio的下载功能为不能下载
            node.setAttribute("id", "voice"); //设置一个id
            return node;
          }

          // static value(node) {
          //  return {
          //   url: node.getAttribute('src')
          //  };
          // }
        }

        AudioBlot.blotName = "audio";
        AudioBlot.tagName = "audio"; //自定义的标签为audio
        Quill.register(AudioBlot);

        // insertEmbed(index: Number(插入的位置), type: String(标签类型), value: any(参数，将传入到create的方法中去), source: String = 'api')
        quill.insertEmbed(length, "audio", { url: file }, "api");
        quill.setSelection(length + 1); //光标位置向后移动一位
      });
    },
    uploadVideo(data) {
      let file = data.file;
      let uploadUrl = this.uploadUrl;
      FileHandler.uploadFile(uploadUrl, file).then(res => {
        // this.fullscreenLoading = false;
        this.fullscreenLoading = false;
        // 获取富文本组件实例
        let quill = this.$refs.myQuillEditor.quill;
        let length = quill.getSelection().index; // 获取光标所在位置
        let BlockEmbed = Quill.import("blots/block/embed");
        class VideoBlot extends BlockEmbed {
          static create() {
            let node = super.create();
            node.setAttribute("src", res.url);
            node.setAttribute("controls", true);
            node.setAttribute("width", 240);
            node.setAttribute("height", 180);
            node.setAttribute("webkit-playsinline", true);
            node.setAttribute("playsinline", true);
            node.setAttribute("x5-playsinline", true);
            return node;
          }
        }

        VideoBlot.blotName = "video";
        VideoBlot.tagName = "video"; //自定义的标签为video
        Quill.register(VideoBlot);

        // insertEmbed(index: Number(插入的位置), type: String(标签类型), value: any(参数，将传入到create的方法中去), source: String = 'api')
        quill.insertEmbed(length, "video", { url: res.url });
        quill.setSelection(length + 1); //光标位置向后移动一位
      });
    },
    async uploadCover(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      if (!image) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning"
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload"].clearFiles();
        return;
      }
      let uploadUrl = this.uploadUrl;
      FileHandler.uploadFile(uploadUrl, file).then(res => {
        // 获取富文本组件实例
        let quill = this.$refs.myQuillEditor.quill;
        // 如果上传成功
        if (res) {
          // 获取光标所在位置
          let length = quill.getSelection().index;
          // 插入图片，res为服务器返回的图片链接地址
          quill.insertEmbed(length, "image", res.url);
          // 调整光标到最后
          quill.setSelection(length + 1);
        } else {
          this.$message.error("图片插入失败");
        }
      });
    }
  }
};
</script>

<style lang="scss">
.ql-container.ql-snow {
  min-height: 400px;
}
.quill-code {
  border: none;
  height: auto;
  > code {
    width: 100%;
    margin: 0;
    padding: 1rem;
    border: 1px solid #ccc;
    border-top: none;
    border-radius: 0;
    height: 10rem;
    overflow-y: auto;
    resize: vertical;
  }
}
.ql-snow.ql-toolbar button.ql-voice {
  background-image: url(../../assets/image/voice.png);
  background-size: 18px 18px;
  background-position: center;
  background-repeat: no-repeat;
}
.quill-editor.ql-editor {
  padding-left: 0;
  padding-top: 0;
  padding-right: 0;
}
.ivu-upload {
  display: none;
}
</style>
